import styled from 'styled-components';
import Box from '../layout/Box';
var IconBase = styled(Box).attrs(function (props) {
  var _props$theme;

  var color = (props === null || props === void 0 ? void 0 : (_props$theme = props.theme) === null || _props$theme === void 0 ? void 0 : _props$theme.colors[props === null || props === void 0 ? void 0 : props.color]) || (props === null || props === void 0 ? void 0 : props.color) || null;
  return {
    as: 'svg',
    display: 'block',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg',
    color: color
  };
}).withConfig({
  displayName: "IconBase",
  componentId: "sc-1liaym9-0"
})({});
export default IconBase;